const SplurgePriority = Object.freeze({
  FOOD_AND_DRINK: 'food_and_drink',
  ACCOMMODATION: 'accommodation',
  FLIGHTS_AND_TRANSPORT: 'flights_and_transport',
  EXPERIENCES_AND_ACTIVITIES: 'experiences_and_activities',
  CULTURE_AND_ATTRACTIONS: 'culture_and_attractions',
  WELLNESS: 'wellness',
  SHOPPING: 'shopping',
  NIGHTLIFE: 'nightlife',
  NONE: 'none',
} as const);

export type SplurgePriority =
  (typeof SplurgePriority)[keyof typeof SplurgePriority];

export const allSplurgePriorities: [SplurgePriority, ...SplurgePriority[]] =
  Object.values(SplurgePriority) as [SplurgePriority, ...SplurgePriority[]];

export default SplurgePriority;
